Vue.component('adults-children-search-params', require('./components/AdultsChildrenSearch.vue').default)

new Vue({
    el: '#adults-children-search-params',
})
